/* ######################################################################################################################## */
/* FUNCTION (ALERT WINDOW) ################################################################################################ */
/* ######################################################################################################################## */
function alertWindow(speed, ease)
{
	jQuery('.js-alert_trigger').on('click', function(e)
	{
		e.preventDefault();
		e.stopPropagation();

		var jQuery_this = jQuery(this);
			idAlert     = jQuery_this.attr('data-alert');

		toggleAlertwindow(idAlert);
	});

	jQuery(document)
		.on('click', function(e)
		{
			if((jQuery('.js-alert_wrapper.open').length > 0) && jQuery('.js-alert_content.highlight', '.js-alert_wrapper.open').length === 0)
			{
				if ($(e.target).closest('.js-alert_content').length === 0)
				{
					jQuery('.js-alert_content', '.js-alert_wrapper.open').addClass('highlight');

					setTimeout(function()
					{
						jQuery('.js-alert_content', '.js-alert_wrapper.open').removeClass('highlight');
					}, 900);
				}
			}
		})
		.keyup(function(e)
		{
			if(jQuery('.js-alert_wrapper.open').length > 0)
			{
				if(e.keyCode == 27)
					closeAlertwindows();
			}
		});
}

/* ######################################################################################################################## */
/* FUNCTION (TOGGLE ALERT WINDOW) ######################################################################################### */
/* ######################################################################################################################## */
function toggleAlertwindow(idAlert)
{
	var speed = '';
		ease  = '';

	jQuery(idAlert).stop(true, true).fadeToggle(speed, ease, function()
	{
		if(jQuery(idAlert).hasClass('open'))
		{
			jQuery(idAlert).removeClass('open');
			document.body.style.overflow = "";
		}
		else
		{
			jQuery(idAlert).addClass('open');
			document.body.style.overflow = "hidden";
		}
	});
}

/* ######################################################################################################################## */
/* FUNCTION (CLOSE ALERT WINDOW) ########################################################################################## */
/* ######################################################################################################################## */
function closeAlertwindows()
{
	jQuery('.js-alert_wrapper').removeClass('open');
	jQuery('.js-alert_content').removeClass('highlight');

	document.body.style.overflow = "";

	jQuery('.js-alert_wrapper').stop(true, true).fadeOut(speed, ease);
}
